import { createSelector } from 'reselect';
import { Property } from '@centecomm/portal-service';

import { LoadStatus, State } from '../../Types';

const propertiesState = ({ properties }: State) => properties;

// Properties
const propertiesSlice = createSelector(propertiesState, ({ properties }) => properties);

export const propertiesLoadStatus = createSelector(propertiesSlice, ({ loadStatus }) => loadStatus);

export const propertiesAreLoaded = createSelector(propertiesLoadStatus, (loadStatus) => loadStatus === LoadStatus.LOADED);

export const properties = createSelector(propertiesSlice, ({ loadStatus, ...rest }) => rest);

export const sortedPropertiesList = createSelector(propertiesState, ({ properties, sortOrder }) =>
    sortOrder.map((i) => properties[i]),
);

export const property = (propertyId: number | string) =>
    createSelector(propertiesSlice, (properties): Property => properties[propertyId] || {});

// Property Occupants
const propertyOccupantSlice = createSelector(propertiesState, ({ propertyOccupants }) => propertyOccupants);

export const propertyOccupants = (propertyId: number | string) =>
    createSelector(propertyOccupantSlice, (propertyOccupants) => propertyOccupants[propertyId] || []);

// Property Spaces
const propertySpacesSlice = createSelector(propertiesState, ({ propertySpaces }) => propertySpaces);

export const propertySpaces = (propertyId: number | string) =>
    createSelector(propertySpacesSlice, (propertySpaces) => propertySpaces[propertyId] || []);

export const spacesAreLoadedForProperty = (propertyId: number | string) =>
    createSelector(propertySpacesSlice, (propertySpaces) => propertySpaces.hasOwnProperty(propertyId));
